<template>
    <button type="button" class="kimsa-file-picker" @click="$refs.input.click()">
        <v-icon size="16" class="mr-2">mdi-paperclip</v-icon>
        <span class="kfp-text" :class="{ 'is-placeholder': !value }">
            {{ value ? value.name : (placeholder || $t('common.select')) }}
        </span>
        <v-icon v-if="value" size="16" class="ml-2 kfp-clear" @click.stop="clear">mdi-close</v-icon>
        <v-icon v-else size="16" class="ml-2">mdi-tray-arrow-up</v-icon>
        <input ref="input" type="file" :accept="accept" class="d-none" @change="onChange">
    </button>
</template>

<script>
export default {
    name: "KimsaFilePicker",
    props: {
        value: {
            type: Object,
            default: null,
        },
        accept: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
    },
    methods: {
        onChange(e) {
            const vm = this
            const files = e.target.files
            vm.$emit('change', files && files.length ? files[0] : null)
        },
        clear() {
            const vm = this
            vm.$emit('change', null)
            if (vm.$refs.input) vm.$refs.input.value = ''
        },
    },
}
</script>

<style scoped>
.kimsa-file-picker {
    display: flex;
    align-items: center;
    width: 100%;
    background: var(--v-field-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 13px;
    color: var(--v-txtPrimary-base);
    font-family: inherit;
    cursor: pointer;
    transition: border-color 0.15s;
}

.kimsa-file-picker:hover {
    border-color: var(--v-txtMuted-base);
}

.kimsa-file-picker .v-icon {
    color: var(--v-txtMuted-base);
}

.kfp-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
}

.kfp-text.is-placeholder {
    color: var(--v-txtMuted-base);
}

.kfp-clear:hover {
    color: var(--v-error-base) !important;
}
</style>
